module.exports = __webpack_public_path__ + "img/afghan_rex.a21b50ab.jpg";